<form [formGroup]="companyForm" class="w100 col gap-16">
    <rr-input
        label="Startup Name"
        [required]="true"
        formControlName="name"
    ></rr-input>
    <rr-input
        label="Webpage"
        formControlName="webpage"
        placeholder="https://www.yourwebpage.com"
    ></rr-input>
    <!-- <div class="col gap-4 w100">
        <label for="pitchdeck" class="color-strong">Pitch Deck</label>
        <div class="row space-between gap-8 align-center w100">
            <rr-btn
                type="Secondary"
                iconStart="upload"
                (click)="pitchdeck.click()"
                *ngIf="!pitchdeckFile"
                >Upload</rr-btn
            >
            <div class="row align-center gap-16" *ngIf="pitchdeckFile">
                <rr-icon class="fileicon" name="file"></rr-icon>
                <div class="pitchdeckname col" [title]="pitchdeckFile.name">
                    <span>{{ pitchdeckFile.name }}</span>
                    <span class="tiny">{{
                        pitchdeckFile.size | calcFileSizeInKb
                    }}</span>
                </div>
            </div>
            <rr-icon
                name="trash"
                color="nutral"
                *ngIf="pitchdeckFile"
                class="deletepitchdeck pointer"
                (click)="deleteFile(pitchdeckFile)"
            ></rr-icon>
        </div>
        <input
            type="file"
            id="pitchdeck"
            hidden
            #pitchdeck
            (change)="onFileSelected($event)"
            [accept]="fileInputAccepts"
        />
    </div> -->
    <!-- <rr-textarea
    label="Our Mission"
    formControlName="mission"
    [required]="true"
    btnType="Secondary"
    btnText="Optimize"
    btnIconStart="ai"
    (btnClick)="optimizeMission()"
  ></rr-textarea> -->

    <div class="row gap-24 align-center justify-center">
    <rr-select-btn
      label="Industry"
      [options]="industryOptions"
      [optionName]="'name_' + lang"
      optionValue="id"
      formControlName="industry"
      [required]="true"
    ></rr-select-btn>
    <div class="row gap-8 infotextarea align-center justify-center">
      <rr-icon name="info" class="w24" color="nutral"></rr-icon>
      <span class="tiny color-strong" i18n
        >This enables us to configure our AI Experts perfectly for your
        needs.</span
      >
    </div>
  </div>
</form>

<rr-spinner *ngIf="loading"></rr-spinner>

